import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import { withRouter } from "react-router-dom";

import "./styles.scss";

class Step3 extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            simulatorHoldings: 1000,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    renderSection1() {
        return (
            <div className="Section1">
                <h1>Pool's earnings</h1>
                <p>Lorem Ipsum</p>
                <div className="PieChartWrapper">
                    <div className="Left">
                        <PieChart
                            data={[
                                { title: "Donations", value: 25, color: "rgb(240, 148, 97)" },
                                { title: "Pool", value: 65, color: "rgb(236, 100,103)" },
                                { title: "Project", value: 5, color: "rgb(238, 126, 111)" },
                                { title: "Team", value: 5, color: "rgb(166, 119,166)" },
                            ]}
                            label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                            labelPosition={100 - 50 / 2}
                            labelStyle={{
                                fill: '#fff',
                                opacity: 0.75,
                                pointerEvents: 'none',
                                fontSize: "0.4em",
                                fontWeight: "bold"
                              }}
                            animate
                        />
                    </div>
                    <div className="Right">
                        <div className="TitleParagraph Color1">
                            <h2>Donations  |  25%</h2>
                            <p>Lorem ipsum</p>
                        </div>
                        <div className="TitleParagraph Color2">
                            <h2>Pool  |  65%</h2>
                            <p>Lorem ipsum</p>
                        </div>
                        <div className="TitleParagraph Color3">
                            <h2>Project  |  5%</h2>
                            <p>Lorem ipsum</p>
                        </div>
                        <div className="TitleParagraph Color4">
                            <h2>Team  |  5%</h2>
                            <p>Lorem ipsum</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSection2() {
        const { simulatorHoldings } = this.state;
        const yearlyEarnings = (Math.round(simulatorHoldings * 100) / 100) * 0.05;
        const monthlyEarnings = Math.round(yearlyEarnings * 100) / 100 / 12;
        return (
            <div className="Section2">
                <h1>Your earnings</h1>
                <p>Lorem Ipsum</p>
                <div className="SimulatorWrapper">
                    <div className="Simulator">
                        <div className="Left">
                            <div className="HoldingsWrapper">
                                <p>Your holdings</p>
                                <input value={simulatorHoldings} onChange={(e: any) => this.setState({ simulatorHoldings: e.target.value })} />
                            </div>
                            <div className="ValueWrapper">
                                <p>Value</p>
                                <em>{"$ " + simulatorHoldings * 2.5}</em>
                            </div>
                            <input
                                className="Slider"
                                type="range"
                                min="100"
                                max="1000000"
                                value={simulatorHoldings}
                                onChange={(e: any) => {
                                    this.setState({ simulatorHoldings: e.target.value });
                                }}
                            />
                        </div>
                        <div className="Right">
                            <p>USD</p>
                        </div>
                    </div>
                    <div className="StatsWrapper">
                        <div className="Stats">
                            <p>Monthly earnings</p>
                            <em>{monthlyEarnings.toFixed(2) + " ADA"}</em>
                        </div>
                        <div className="Divider" />
                        <div className="Stats">
                            <p>Yearly earnings</p>
                            <em>{yearlyEarnings.toFixed(2) + " ADA"}</em>
                        </div>
                        <div className="Divider" />
                        <div className="Stats">
                            <p>Yearly yield</p>
                            <em>~ 5%</em>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="Step3MainWrapper">
                {this.renderSection1()}
                {this.renderSection2()}
            </div>
        );
    }
}

export default withRouter(Step3);
